module.exports = __webpack_public_path__ + "media/images/starry-sky-703c577065f16121f00b207f08e1c8c5.png";